import type { BrowserTabs, TabType } from './types'

export const VISIBLE_CORE_TABS: TabType[] = [
  'Window3D',
  'CorrelationScheme',
  'Interpretation',
  'GeoModule',
]
export const VISIBLE_BROWSER_TABS: BrowserTabs[] = [
  'Stratigraphy',
  'BulkImport',
  'Cartography',
  'DataManager',
  'CrossPlotBrowser',
  'Modeling',
]
